// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4fc268f5","455":"4442bf51","488":"67361ce5"}[chunkId] + ".chunk.js";
};